import axios from 'axios';

// Create a new Axios instance with default headers
const axiosInstance = axios.create();

// Set default headers
axiosInstance.defaults.headers.common['RequestSource'] = 'Client';
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

// Extend Axios to include other functions
axiosInstance.all = axios.all;
axiosInstance.spread = axios.spread;

export default axiosInstance;
